var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"hwm-bypass"},[_c('li',[_c('a',{attrs:{"id":"bypass-main","href":"#main"}},[_vm._v(_vm._s(_vm.bypassMain))])]),_c('li',[_c('a',{attrs:{"id":"bypass-footer","href":"#main-menu"}},[_vm._v(_vm._s(_vm.bypassFooter))])])])}
var staticRenderFns = []

export { render, staticRenderFns }